import React, { useState } from 'react'
import {
  Switch,
  FormControlLabel,
  Typography,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import * as userActions from '../../userActions'

export const StatusSwitch = ({ user, firmId, isStaffOwner, dispatch }) => {
  const isActive =
    !user.portal_disabled_firms?.includes(Number(firmId)) || false

  const [isUpdating, setIsUpdating] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)

  const handleSwitchChange = () => {
    if (isActive) {
      setConfirmOpen(true)
    } else {
      updateStatus(true)
    }
  }

  const updateStatus = async enable => {
    setIsUpdating(true)
    try {
      await dispatch(
        userActions.sendUpdatePortalAccess({
          userId: user._id,
          firmId: Number(firmId),
          enable,
        }),
      )
    } catch (error) {
      console.error('Failed to update user status:', error)
      alert('Failed to update user status. Please try again.')
    } finally {
      setIsUpdating(false)
      dispatch(userActions.invalidateList('_firm', firmId))
      dispatch(userActions.fetchListIfNeeded('_firm', firmId))
      setConfirmOpen(false)
    }
  }

  if (!isStaffOwner) {
    return null
  }

  return (
    <Box>
      <Typography
        variant="h4"
        gutterBottom
      >
        Status
      </Typography>

      <Box
        display="flex"
        alignItems="center"
        gap={2}
      >
        <FormControlLabel
          control={
            <Switch
              checked={isActive}
              onChange={handleSwitchChange}
              disabled={isUpdating || !user._id || !firmId}
              sx={{
                '& .MuiSwitch-thumb': {
                  boxShadow: '0 0 2px rgba(0,0,0,0.6)',
                },
              }}
            />
          }
          label={isActive ? 'Active' : 'Inactive'}
        />

        {isUpdating && (
          <CircularProgress
            size={20}
            thickness={5}
          />
        )}
      </Box>

      {!isActive && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', margin: 2 }}
        >
          This user is inactive and can no longer access portals.
        </Typography>
      )}

      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
      >
        <DialogTitle>Confirm Inactivation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Setting this contact as inactive will revoke their access to all
            granted portals. Are you sure you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmOpen(false)}
            color="inherit"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={() => updateStatus(false)}
            color="error"
            variant="contained"
            size="large"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
